import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { site } from '../../configs/site';
import { preloadHubSpotFormsScript } from '../../services/HubSpotForms';

// Big "talk to us" banner shown at the bottom of every use case page,
// directly above the blue SiteFooter (see UseCaseView.jsx). Pulls its copy
// from site.contact (site.js) -- the same config the homepage hero's small
// secondary button already reads `enabled`/`buttonLabel` from, but
// `title`/`description` were sitting unused until now. Toggling
// site.contact.enabled off hides this banner everywhere it's used, same as
// it already does for the homepage button.
const ContactCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!site.contact.enabled) {
    return null;
  }

  return (
    <div className="w-full border-t border-gray-200 bg-gray-50">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-4 px-4 py-14 text-center sm:px-6 lg:px-10">
        <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl">
          {site.contact.title}
        </h2>

        <p className="max-w-2xl text-base text-gray-600">
          {site.contact.description}
        </p>

        <button
          type="button"
          // Carries the use case page's own path along as router state, so
          // ContactView's "Back" link can return here instead of always
          // going to the homepage -- see ContactView.jsx.
          onClick={() => navigate('/contact', { state: { from: location.pathname } })}
          // See services/HubSpotForms.js -- starts fetching the contact
          // form's HubSpot script as soon as a visitor's finger/cursor
          // reaches this button, instead of only after they've already
          // landed on /contact.
          onMouseEnter={preloadHubSpotFormsScript}
          onTouchStart={preloadHubSpotFormsScript}
          className="mt-2 inline-flex items-center gap-2 rounded-lg bg-primary-600 px-8 py-4 text-base font-semibold text-white shadow-sm transition hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        >
          {site.contact.buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default ContactCTA;
